import React from 'react';
import Breadcrumb from '../Breadcrumb';
import { ResponsiveHeroProps } from './props';
import styles from './style.module.scss';
import classNames from '../../../utils/classNames';

const ResponsiveHero = ({ title, subtitle, image, breadcrumbs }: ResponsiveHeroProps) => {
  const TitleHeadingElement = title.headingElement;
  const SubtitleHeadingElement = subtitle.headingElement;

  const backgroundStyle: React.CSSProperties = {};
  Object.entries(image.breakpoints).forEach(([breakpoint, url]) => {
    (backgroundStyle as any)[`--hero-bg-${breakpoint}`] = `url(${url})`;
  });

  return (
    <div className={classNames('hero-banner', styles)} style={backgroundStyle}>
      <div className={classNames('hero-breadcrumbs', styles)}>
        <Breadcrumb items={breadcrumbs.items} />
      </div>
      <div className={classNames('hero-banner__content', styles)}>
        {title.text && (
          <TitleHeadingElement className={classNames('hero-banner__title', styles)}>
            {title.text}
          </TitleHeadingElement>
        )}
        {subtitle.text && (
          <SubtitleHeadingElement
            className={classNames('hero-banner__subtitle', styles)}
            dangerouslySetInnerHTML={{ __html: subtitle.text }}
          />
        )}
      </div>
    </div>
  );
};

export default ResponsiveHero;
